'use strict';

import angular from 'angular';
import ListController from './list.controller';

export default angular.module('logServerApp.main.list', [])
  .controller('ReportListController', ListController)
  .name;



// WEBPACK FOOTER //
// ./client/app/main/list/index.js